import { gql } from "@apollo/client";

export const SEARCH_ALL_PENDING_DEPOSITS = gql`
query searchDeposits($q: String!, $limit: Int!, $offset: Int!) {
    searchDeposits(q: $q, limit: $limit, offset: $offset) {
      id
      referenceNumber
      pickupDateTime
      dropoffDateTime
      customer {
        firstName
        lastName
      }
      businessCustomer{
        businessName
      }
      depositDetails {
        amount
        amountAdjusted
        payment {
          amount
          remainingAmount
          refundAmount
        }
        refund {
          amount
          status
          currency
        }
      }  
    }
  }
`;


